import {Component} from '@angular/core';

@Component({
    selector: 'user-list-compoenent',
    templateUrl: './user-list.component.html'
})

export class UserListComponent { }



// WEBPACK FOOTER //
// /home/xpro/Documentos/ances/myjangular/src/app/users/user-list/user-list.component.ts